import React from 'react';
import PropTypes from 'prop-types';
import Svg, { Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function TransactionIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;

  return (

    <Svg
      {...svgProps}
      viewBox="0 0 34 32">
      <Path
        d="M20 2c7.732 0 14 6.268 14 14s-6.268 14-14 14v-3c2.938 0 5.701-1.144 7.778-3.222s3.222-4.84 3.222-7.778c0-2.938-1.144-5.701-3.222-7.778s-4.84-3.222-7.778-3.222c-2.938 0-5.701 1.144-7.778 3.222-1.598 1.598-2.643 3.601-3.041 5.778h5.819l-7 8-7-8h5.143c0.971-6.784 6.804-12 13.857-12zM26 14v4h-8v-10h4v6z"
        fill={color}></Path>
    </Svg>

  );
}

TransactionIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

TransactionIcon.defaultProps = {
  height: 120,
  width: 120,
};

export default pure(TransactionIcon);
